<div class="example-container mat-elevation-z8">


  <div class="example-table-container">

    <table mat-table [dataSource]="data" class="example-table" matSort (matSortChange)="onSortData($event)">



      <ng-container [matColumnDef]="column" *ngFor="let column of displayedColumns">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> {{printCol(column)}} </th>
        <td mat-cell *matCellDef="let element" [ngClass]="'td_width '+column">
          {{printElement(column,element)}}
          <mat-icon *ngIf="column == 'azioni' && showDettaglio" class="green" (click)="handleIconClick(element, 'dettaglio')"
            matTooltip="{{detailIconToolTip}}">search</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && showAssociaCompetenze" class="green"
            (click)="handleIconClick(element, 'competenze')" matTooltip="Associa competenze">menu</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && showAssociaConoscenze" class="green"
            (click)="handleIconClick(element, 'conoscenze')" matTooltip="Associa conoscenze">dialpad</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && showAssociaClassificazioni && checkException(element)" class="green"
            (click)="handleIconClick(element, 'classificazioni')" matTooltip="Associa classificazioni">queue</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showAssociaAbilita" class="green"
            (click)="handleIconClick(element, 'abilita')" matTooltip="Associa abilità">assignment </mat-icon>

          <!-- assemblea icone -->


          <mat-icon *ngIf="column == 'azioni' && showAssociazioniProfiliAssemblea && element.stato.id != 1" class="green"
            (click)="handleIconClick(element, 'associazioneProfiliAssemblea')" matTooltip="Mostra associazioni profili">dialpad</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && showAssociazioniCompetenzeAssemblea && element.stato.id != 1" class="green"
            (click)="handleIconClick(element, 'associazioneCompetenzeAssemblea')"
            matTooltip="Mostra associazioni competenze">menu</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && editAssociazioniProfiliAssemblea && element.stato.id == 1" class="green"
            (click)="handleIconClick(element, 'editAssociazioneProfiliAssemblea')" matTooltip="Associa profili professionali">dialpad</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && editAssociazioniCompetenzeAssemblea && element.stato.id == 1" class="green"
            (click)="handleIconClick(element, 'editAssociazioneCompetenzeAssemblea')"
            matTooltip="Associa competenze">menu</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showEliminaAssemblea && element.stato.id == 1" (click)="handleIconClick(element, 'eliminaAssemblea')"
            matTooltip="Elimina" class="green">delete</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showApprovaContenuti && element.stato.id == 1" (click)="handleIconClick(element, 'approvaContenuti')"
            matTooltip="Approva i contenuti dell'assemblea" class="green">lock</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showDecreta && element.stato.id == 2" class="green"
            (click)="handleIconClick(element, 'decretaAssemblea')" matTooltip="Decreta Assemblea" class="green">library_books</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showDecreta && element.stato.id == 2" class="green"
            (click)="handleIconClick(element, 'pubblicaAssemblea')" matTooltip="Decreta e pubblica assemblea" class="green">check</mat-icon>



          <!-- fine assemblea icone -->

          <!-- gestione aree -->

          <mat-icon *ngIf="column == 'azioni' && showDettaglioArea" class="green" 
            (click)="handleIconClick(element, 'dettaglioArea')" matTooltip="Visualizza dettaglio">search</mat-icon>
          <mat-icon *ngIf="column == 'azioni' && showModificaArea && element.statoArea.id !== 3" class="green"
            (click)="handleIconClick(element, 'modificaArea')" matTooltip="Modifica Area">edit</mat-icon>
          
          <!-- fine gestione aree -->


          <mat-icon *ngIf="column == 'azioni' && modificaPropostaCompetenza && element.modificaCompetenza" class="green"
            (click)="handleIconClick(element, 'modificaCompetenza')" matTooltip="Modifica proposta competenza">edit</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && validaCompetenza && element.modificaCompetenza" class="green"
            (click)="handleIconClick(element, 'validaCompetenza')" matTooltip="Valida proposta competenza">check</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && validaCompetenza && element.modificaCompetenza" class="green"
            (click)="handleIconClick(element, 'rifiutaCompetenza')" matTooltip="Rifiuta proposta competenza">cancel</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && modificaProfiloProfessionale && element.statoProposta.id != 5"
            class="green" (click)="handleIconClick(element, 'dettaglioProfilo')"
            matTooltip="Modifica proposta profilo professionale">edit</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && validaProfilo && element.statoProposta.id != 5" class="green"
            (click)="handleIconClick(element, 'validaProfilo')" matTooltip="Valida proposta profilo professionale">check</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && !isAssistenza && validaProfilo && element.statoProposta.id != 5" class="green"
            (click)="handleIconClick(element, 'rifiutaProfilo')" matTooltip="Rifiuta proposta profilo professionale">cancel</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showElimina" (click)="handleIconClick(element, 'elimina')"
            matTooltip="Elimina" class="green">delete</mat-icon>

          <mat-icon
            *ngIf="column == 'azioni' && !isAssistenza && showDisabilitaUtente && (element.flagAttivo && element.flagAttivo != 'NO')"
            (click)="handleIconClick(element, 'disabilitaUtente')" matTooltip="Disabilita Utente"
            class="icon-red">cancel</mat-icon>

          <mat-icon
            *ngIf="column == 'azioni' && !isAssistenza  && (element.flagAttivo && element.flagAttivo == 'NO')"
            (click)="handleIconClick(element, 'abilitaUtente')" matTooltip="Abilita Utente"
            class="green">check_circle</mat-icon>


          <mat-icon
            *ngIf="column == 'azioni' && showAbilitaOperatore && (element.flagAttivo && element.flagAttivo == 'NO')"
            class="green" (click)="handleIconClick(element, 'abilitaOperatore')" matTooltip="Abilita operatore">check</mat-icon>

          <mat-icon
            *ngIf="column == 'azioni' && showDisabilitaOperatore && (element.flagAttivo && element.flagAttivo == 'SI')"
            class="green" (click)="handleIconClick(element, 'disabilitaOperatore')" matTooltip="Disabilita operatore">cancel</mat-icon>

          <mat-icon *ngIf="column == 'azioni' && showArchivioProposte && element.statoProposta.id == 7" class="green"
            (click)="handleIconClick(element, 'duplicaProfilo')" matTooltip="Duplica profilo">file_copy</mat-icon>

          <mat-icon
            *ngIf="column == 'azioni' && !isAssistenza && showArchivioCompetenze && (element.tipologia.id == 1 && element.stato.id == 7)"
            class="green" (click)="handleIconClick(element, 'archiviaCompetenza')" matTooltip="Archivia competenza">archive</mat-icon>

          <mat-icon
            *ngIf="column == 'azioni' && !isAssistenza && showArchivioCompetenze && element.stato.id == 7"
            class="green"
            (click)="handleIconClick(element, 'duplicaCompetenza')"
            matTooltip="Duplica competenza">file_copy</mat-icon>


          <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showArchivioProposte && element.statoProposta.id == 7" class="green"
            (click)="handleIconClick(element, 'archiviaProposta')" matTooltip="Archivia proposta">archive</mat-icon>


            <mat-icon *ngIf="column == 'azioni' && showAbilitaConoscenze" class="green" (click)="handleIconClick(element, 'detailAbilitaConoscenze')"
            matTooltip="Visualizza dettaglio">search</mat-icon>




          <mat-icon *ngIf="column == 'azioni' && !isAssistenza && showInvia" matTooltip="Invia ad un tecnico"
            (click)="handleIconClick(element, 'invia')" class="green">send</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && showCaricaDocumenti" matTooltip="Sostituisci documento"
            (click)="handleIconClick(element, 'sostituisciDoc')" class="green">find_replace</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && showCaricaDocumenti" matTooltip="Elimina documento"
            (click)="handleIconClick(element, 'eliminaDoc')" class="green">cancel</mat-icon>

            <mat-icon *ngIf="column == 'azioni' && showCaricaDocumenti" matTooltip="Scarica PDF documento"
            (click)="handleIconClick(element, 'scaricaDocPdf')" class="green">file_copy</mat-icon>


        </td>

      </ng-container>




      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;" style="height:24px !important;"></tr>
    </table>
  </div>

  <mat-paginator #paginator [pageSize]="pageSize" [pageSizeOptions]="[10, 50, 100, 250, 500, 750, 1000]" [length]="paginatorSize" [pageIndex]="pageIndex"
    (page)="onPaginateChange($event)" showFirstLastButtons></mat-paginator>

  <!-- <mat-paginator [length]="paginatorSize" [pageSize]="10" aria-label="Seleziona pagina"
    showFirstLastButtons  (page)="pageEvent = $event; onPaginateChange($event)"></mat-paginator> -->
</div>
